import { Box } from '@material-ui/core';
import React, { Component } from 'react'
import Introduction from './Introduction/Introduction.js';
import Projects from './Projects/Projects.js';
import { Grid } from '@mui/material';

class UIRefereshment extends Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            projectHeight: 0,
        }
        this.handleHeight = this.handleHeight.bind(this)
        this.handleProjectHeight = this.handleProjectHeight.bind(this)
        this.callProjectDetails = React.createRef()
        this.handleProjectCompleteLoading = this.handleProjectCompleteLoading.bind(this)
    }

    handleHeight(childData) {
        this.setState({
            height: childData
        })
    }

    handleProjectHeight(childData) {
        this.setState({
            projectHeight: childData
        })
        // alert(childData)
    }


    handleProjectCompleteLoading() {
        // if (localStorage.getItem('lastSelectedProject')) {
        //     this.callProjectDetails.current.getData(JSON.parse(localStorage.getItem('lastSelectedProject')))
        // }
    }

    screenSizeCheck() {
        if (window.innerWidth > 1600) {
            return true
        } else {
            return false
        }
    }


    render() {
        return (
            <div>
                <Box marginTop={1} style={{ display: 'flex', flexDirection: 'row' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <Introduction
                                projectHeight={this.state.projectHeight !== 0 && this.state.projectHeight}
                                access={this.props.access}
                            />
                        </Grid>
                        <Grid item xs={9}>
                            <Projects
                                ref={this.callProjectDetails}
                                height={this.state.height !== 0 && this.state.height}
                                handleHeight={this.handleHeight}
                                projectHeight={this.handleProjectHeight}
                                access={this.props.access}
                                projectCompleteLoading={this.handleProjectCompleteLoading}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </div>
        )
    }
}

export default UIRefereshment;
